export default "__VITE_ASSET__BnkQsBkz__"